<template>
  <v-container class="pa-0 cropper-container" fluid>
    <div class="pa-5" style="background-color: #f7f7f7;">
      <v-btn small depressed fab class="accent white--text" @click="close">
        <font-awesome-icon icon="arrow-left" />
      </v-btn>
      <h2 class="mt-4 accent--text" style="font-weight: 300; font-size: 30px;">Upload image</h2>
    </div>
    <div>
      <input ref="input" type="file" accept="image/*" @change="setImage" />

      <div
        class="pa-3"
        style="display: flex; justify-content: space-between; background-color: #3F51B5;"
      >
        <v-btn text class="white--text" @click="showFileChooser">Upload Image</v-btn>
        <v-btn v-if="branding.length < 3" text class="white--text" @click="save">save</v-btn>
        <v-btn v-if="branding.length === 3" text class="white--text" @click="change">change</v-btn>
      </div>
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <div class="img-cropper">
            <vue-cropper ref="cropper" :aspect-ratio="aspectRatio" :src="offerImg" alt=" " />
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-row v-if="offerImg" style="background-color: #fff;">
            <v-col cols="2">
              <v-chip pill small class="pa-0 ml-8">
                <v-btn fab class="black--text" @click.prevent="zoom(0.2)">
                  <font-awesome-icon icon="search-plus" />
                </v-btn>
              </v-chip>
            </v-col>

            <v-col cols="2">
              <v-chip pill small class="pa-0 ml-8">
                <v-btn fab class="black--text" @click.prevent="zoom(-0.2)">
                  <font-awesome-icon icon="search-minus" />
                </v-btn>
              </v-chip>
            </v-col>

            <v-col cols="2">
              <v-chip pill small class="pa-0 ml-8">
                <v-btn fab class="black--text" @click.prevent="rotate(90)">+90deg</v-btn>
              </v-chip>
            </v-col>

            <v-col cols="2">
              <v-chip pill small class="pa-0 ml-8">
                <v-btn fab class="black--text" @click.prevent="rotate(-90)">-90deg</v-btn>
              </v-chip>
            </v-col>

            <v-col cols="2">
              <v-chip pill small class="pa-0 ml-8">
                <v-btn fab class="black--text" @click.prevent="reset">
                  <font-awesome-icon icon="undo" />
                </v-btn>
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  props: {
    uploadImg: Function,
    aspectRatio: Number,
    branding: Array
  },

  components: {
    VueCropper
  },

  data() {
    return {
      offerImg: "",
      saveImg: "",
      changeImg: "",
      data: null
    };
  },
  methods: {
    close() {
      this.$emit("closeCropper");
    },

    save() {
      this.saveImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg", 0.5);
      this.$emit("save", this.saveImg);
      this.close();
    },

    change() {
      this.changeImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg", 0.5);
      this.$emit("change", this.changeImg);
      this.close();
    },

    reset() {
      this.$refs.cropper.reset();
    },

    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },

    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          var img = document.createElement("img");
          img.src = event.target.result;

          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var MAX_WIDTH = 500;
          var MAX_HEIGHT = 500;
          var width = img.width;
          var height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          this.offerImg = img.src;
          this.$refs.cropper.replace(img.src);
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input[type="file"] {
  display: none;
}

.img-cropper {
  max-width: 100%;
}

.preview {
  overflow: hidden;
}

.cropper-container {
  height: 100%;
  background-color: #f7f7f7;
}
</style>
